define.alias("checkout/components/seamless-checkout/feature-banner", "calendar/components/seamless-checkout/feature-banner");